import { isValidCNPJ, validDDDs } from './basicUtils';
import { validateCPF } from 'features/Signup/pages/SignupTourOrganizer/utils';

export interface BusinessWarnings {
  document?: string;
  cep?: string;
  phone?: string;
  email?: string;
  [key: string]: string | undefined;
}

export const checkBusinessWarnings = (values: any): string[] => {
  const warnings: string[] = [];

  // Validação de CNPJ ou CPF no campo document
  if (values?.document) {
    const rawDoc = String(values.document).replace(/\D/g, '');
    if (rawDoc.length > 0) {
      if (rawDoc.length === 11) {
        if (!validateCPF(rawDoc)) {
          warnings.push('O CPF informado parece inválido.');
        }
      } else if (rawDoc.length === 14) {
        if (!isValidCNPJ(rawDoc)) {
          warnings.push('O CNPJ informado parece inválido.');
        }
      } else {
        warnings.push('O documento (CPF/CNPJ) preenchido está incompleto ou inválido.');
      }
    }
  }

  // Validação de CEP
  const zipCode = values?.address?.zipCode || values?.zipCode;
  if (zipCode) {
    const rawCep = String(zipCode).replace(/\D/g, '');
    if (rawCep.length > 0) {
      if (rawCep.length !== 8 || /^(.)\1+$/.test(rawCep)) {
        warnings.push('O CEP informado parece inválido.');
      }
    }
  }

  // Validação de DDD / Telefone
  const phone = values?.phone || values?.whatsapp;
  if (phone) {
    const matchDdd = String(phone).match(/^\((\d{2})\)/);
    const digits = String(phone).replace(/\D/g, '');
    if (digits.length > 0) {
      if (matchDdd && !validDDDs.includes(matchDdd[1])) {
        warnings.push('O DDD do telefone/WhatsApp parece inválido.');
      } else if (/^(\d)\1+$/.test(digits)) {
        warnings.push('O telefone não pode conter todos os números repetidos.');
      } else if (digits.length < 10) {
        warnings.push('O telefone/WhatsApp informado está incompleto.');
      }
    }
  }

  // Validação de E-mail comercial
  const email = values?.tradeEmail || values?.email;
  if (email && typeof email === 'string' && email.trim().length > 0) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email.trim())) {
      warnings.push('O e-mail informado parece inválido.');
    }
  }

  return warnings;
};
